// types
import { IP_RoomAutomation } from './types'
// components
import { IAutomationObject } from '../../../types';
import { isParameterApp } from '../../../parameterApps';
import { OperatorPanelWrapperFullSize } from '../../../components/Layout';
import { ORIENTATION, RoomsOverviewPanel } from '../../../SubPlants/SP_Room/RoomsOverviewPanel';
import ActiveLightsPanel from '../../../Devices/Light/ActiveLightsPanel';
import { schema as schemaFloor } from '../P_Floor/types'
import { LoadingView } from '../../../../components';
import { useGetObjectsChildren } from '../../../../hooks/useGetObjectsChildren';
import { FilteredAppsView } from '../../../components/FilteredAppsView';
import { FormattedMessage } from 'react-intl';
import OpenWindowPanel from '../../../Devices/WindowContact/OpenWindowPanel';
import { RoomsTemperatures } from '../../../SubPlants/SP_Room';


export function OperatorPanel(props: IP_RoomAutomation) {
    const { children, error, isLoading, isSuccess } = useGetObjectsChildren(props.resourceGroupId, props.id);
    
    return (
        <OperatorPanelWrapperFullSize objectId={props.id} resourceGroupId={props.resourceGroupId}
            statusContent={
                <>
                    <RoomsOverviewPanel orientation={ORIENTATION.Horizontal} parentId={props.id} resourceGroupId={props.resourceGroupId}></RoomsOverviewPanel>
                    <ActiveLightsPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></ActiveLightsPanel>
                    <OpenWindowPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></OpenWindowPanel>

                    <RoomsTemperatures parentId={props.id} resourceGroupId={props.resourceGroupId}></RoomsTemperatures>
                </>
            }>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <FilteredAppsView header={<FormattedMessage id="P_Floor.Floors" defaultMessage={'Floors'} />} sort={sortFloors} apps={children ?? []} filter={floorFilter}></FilteredAppsView>
                <FilteredAppsView apps={children ?? []} filter={allTheRestFilter}></FilteredAppsView>
            </LoadingView>
        </OperatorPanelWrapperFullSize>

    );
}

const floorFilter = (a: IAutomationObject) => {
    return a.schema === schemaFloor;
}

const allTheRestFilter = (a: IAutomationObject) => {
    return a.schema !== schemaFloor && !isParameterApp(a.schema);
}

const sortFloors = (a: any, b: any) =>((b.floorNumber ?? 0) - (a.floorNumber ?? 0));